export default {"src":"/_next/static/media/oil.3f365be3.svg","height":96,"width":96};